import React, {Component} from "react"
import PropTypes from "prop-types"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import {AreYouSurePopUp} from "../../AreYouSurePopUp"

class UserViewButton extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired
  }

  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  openRemoveUserPopUp = () => {
    this.deactivatePopup.toggle()
  }

  removeUser = () => {
    const {user, onRemove} = this.props
    onRemove(user)
  }

  render() {
    const {user, formatMessage} = this.props

    return (
      <div>
        <Button id="adminSection_removeUser_button" small onClick={this.openRemoveUserPopUp}>
          <FormattedMessage id="admin.components.userRemoveButton.button.remove" />
        </Button>
        <AreYouSurePopUp
          ref={(c) => {
            this.deactivatePopup = c
          }}
          onSubmit={this.removeUser}
          text={formatMessage({id: "admin.components.userRemoveButton.areYouSurePopUp.text"}, {firstname: user.firstName})}
          buttonText={formatMessage({id: "admin.components.userRemoveButton.areYouSurePopUp.buttonText"})}
        />
      </div>
    )
  }
}

export default injectIntl(UserViewButton)
